import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useApplications } from '../context/ApplicationContext';
import Button from '../components/Button';
import Card, { CardBody } from '../components/Card';
import { FileTextIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
const ApplicationAttacher: React.FC = () => {
  const {
    user
  } = useAuth();
  const {
    simulateApplication
  } = useApplications();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [referenceNumber, setReferenceNumber] = useState('');
  const handleAttachApplication = () => {
    if (!user) {
      setError('You must be logged in to attach an application');
      return;
    }
    setIsSubmitting(true);
    setError(null);
    try {
      // Create a simulated application
      const application = simulateApplication({
        userId: user.id,
        userName: user.name || 'Test User',
        userEmail: user.email || 'test@example.com',
        serviceId: 'SVC-101',
        serviceName: 'Tax Clearance Certificate',
        mdaId: 'MDA-001',
        mdaName: 'Edo State Internal Revenue Service',
        formData: {
          fullName: user.name,
          email: user.email,
          phoneNumber: '08012345678',
          address: '123 Main Street, Benin City',
          taxId: 'TIN' + Math.floor(Math.random() * 1000000).toString()
        },
        fee: 2500,
        isPaid: false
      });
      setReferenceNumber(application.referenceNumber);
      setIsSuccess(true);
    } catch (err) {
      console.error('Error attaching application:', err);
      setError('Failed to attach application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleViewApplication = () => {
    navigate(`/track-application/${referenceNumber}`);
  };
  return <Card data-id="element-7040">
      <CardBody className="p-6" data-id="element-7041">
        {isSuccess ? <div className="text-center" data-id="element-7042">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100" data-id="element-7043">
              <CheckCircleIcon className="h-6 w-6 text-green-600" data-id="element-7044" />
            </div>
            <h3 className="mt-2 text-lg font-medium text-gray-900" data-id="element-7045">
              Application Attached Successfully
            </h3>
            <p className="mt-2 text-sm text-gray-500" data-id="element-7046">
              Your application has been successfully created and attached with
              reference number:
            </p>
            <p className="mt-2 text-lg font-bold text-green-600" data-id="element-7047">
              {referenceNumber}
            </p>
            <div className="mt-6" data-id="element-7048">
              <Button variant="primary" onClick={handleViewApplication} data-id="element-7049">
                View Application
              </Button>
            </div>
          </div> : <>
            <div className="text-center mb-6" data-id="element-7050">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100" data-id="element-7051">
                <FileTextIcon className="h-6 w-6 text-blue-600" data-id="element-7052" />
              </div>
              <h3 className="mt-2 text-lg font-medium text-gray-900" data-id="element-7053">
                Create Test Application
              </h3>
              <p className="mt-2 text-sm text-gray-500" data-id="element-7054">
                This will create a simulated application for testing purposes.
                You can track and view this application just like a real one.
              </p>
            </div>
            {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md flex items-center" data-id="element-7055">
                <AlertCircleIcon className="h-5 w-5 mr-2" data-id="element-7056" />
                <span data-id="element-7057">{error}</span>
              </div>}
            <Button variant="primary" fullWidth onClick={handleAttachApplication} disabled={isSubmitting} data-id="element-7058">
              {isSubmitting ? 'Creating Application...' : 'Create Test Application'}
            </Button>
          </>}
      </CardBody>
    </Card>;
};
export default ApplicationAttacher;